import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { id: "o-nas", label: "O nas" },
  { id: "oferta", label: "Oferta" },
  { id: "dlaczego-my", label: "Dlaczego my" },
  { id: "galeria", label: "Galeria" },
  { id: "opinie", label: "Opinie" },
  { id: "kontakt", label: "Kontakt" },
];

export default function Navbar({ onOpenQuote }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-black/70 border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <a
          href="#hero"
          data-testid="nav-logo"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-3 group"
        >
          <span className="w-8 h-8 border border-white/40 flex items-center justify-center font-serif-display text-base">
            M
          </span>
          <span className="font-serif-display text-xl tracking-wide leading-none">
            <span className="block text-[10px] uppercase tracking-[0.35em] text-neutral-400 font-sans">Kamieniarstwo</span>
            Mrozek
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-[12px] uppercase tracking-[0.25em] text-neutral-300 hover:text-white transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:block">
          <button data-testid="nav-cta-quote" className="btn-primary" onClick={onOpenQuote}>
            Darmowa wycena
          </button>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-white"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 bg-black/95 backdrop-blur-xl">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`mobile-nav-link-${l.id}`}
                onClick={() => go(l.id)}
                className="text-left text-sm uppercase tracking-[0.25em] text-neutral-300"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="mobile-nav-cta-quote"
              className="btn-primary justify-center"
              onClick={() => {
                setOpen(false);
                onOpenQuote();
              }}
            >
              Darmowa wycena
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
